import { useState } from 'react';
import {
  Box, Container, List, ListItem, ListItemIcon, ListItemText,
  SvgIcon, SwipeableDrawer, Collapse, ListItemButton
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { grey } from '@mui/material/colors';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

import Header from './Header';
import Footer from './Footer';
import { menuDrawer } from './menuUsuario';
import { logout } from '../../actions/auth';

import { useDispatch, useSelector } from 'react-redux';

const Layout = ({
  busqueda = false, search = '', buscar, ...props
}) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);

  const [showMenu, setShowMenu] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const route = location.pathname;

  const irA = where => () => {
    setShowMenu(false);
    navigate(where);
  }

  const validateRoute = (routeValidate) => {
    return routeValidate == route ? 'item-select' : '';
  }

  const iconColor = (routeValidate) => {
    return routeValidate == route ? grey[50] : grey[600];
  }

  const list = () => (
    <Box
      sx={{ width: 300 }}
      onClick={() => setShowMenu(false)}
      onKeyDown={() => setShowMenu(false)}
    >
      <div className="content">
        <img src="/logo.png" width={"90%"} />
        <List className="aside">
          {
            menuDrawer.map((item, index) => {
              const link = item.nombre === 'Favoritos' && user ? `${item.click}/${user._id}` : item.click;
              return (
                <ListItem
                  key={`menu-${index}`}
                  onClick={irA(link)}
                  className={`item-aside ${validateRoute(link)}`}
                >
                  <ListItemIcon>
                    <SvgIcon component={item.iconName} sx={{ color: iconColor(link) }} />
                  </ListItemIcon>
                  <ListItemText primary={item.nombre} />
                </ListItem>
              )
            })
          }
          <ListItem onClick={() => dispatch(logout())} className="item-aside">
            <ListItemIcon>
              <ExitToAppOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesión" />
          </ListItem>
        </List>
      </div>
    </Box>
  );

  return (
    <>
      <SwipeableDrawer
        anchor="left"
        open={showMenu}
        onClose={() => setShowMenu(false)}
        onOpen={() => setShowMenu(true)}
        className="aside-content"
      >
        {
          list()
        }
      </SwipeableDrawer>
      <Container maxWidth="lg" sx={{ marginBottom: '3rem', minHeight: '60vh' }}>
        <Header
          busqueda={busqueda}
          newSearch={search}
          buscar={buscar}
          showMenu={showMenu}
          changeMenu={() => setShowMenu(!showMenu)}
        />
        {
          props.children
        }
      </Container>
      <Footer />
    </>
  )
}

export default Layout;
